import { type TabPaneProps, Tabs, type TabsProps } from 'antd';
import type { FC } from 'react';
import { ReactComponent as MoreIcon } from '../../../assets/icons/tab-more.svg';

interface TabProps
  extends Pick<
    TabsProps,
    | 'onChange'
    | 'defaultActiveKey'
    | 'activeKey'
    | 'className'
    | 'destroyInactiveTabPane'
    | 'tabBarExtraContent'
    | 'tabBarGutter'
  > {
  contents: {
    title: string;
    content: TabPaneProps['children'];
    contentKey: string;
  }[];
}

const Tab: FC<TabProps> = ({
  contents,
  defaultActiveKey = '1',
  onChange = () => {},
  activeKey,
  className,
  destroyInactiveTabPane = false,
  tabBarExtraContent = false,
  tabBarGutter,
}) => {
  return (
    <Tabs
      destroyInactiveTabPane={destroyInactiveTabPane}
      moreIcon={<MoreIcon />}
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      className={className ? className : 'common-tabs'}
      onChange={onChange}
      tabBarExtraContent={tabBarExtraContent}
      tabBarGutter={tabBarGutter}
      items={contents?.map(({ title, content, contentKey }, key) => ({
        key: contentKey ?? String(key + 1),
        // biome-ignore lint/a11y/noLabelWithoutControl: <explanation>
        label: <label className="tab-title cursor-pointer">{title}</label>,
        children: content,
      }))}
    />
  );
};

export default Tab;
